// extracted by mini-css-extract-plugin
export default {"wrapper":"aq-z","response":"bq-z","error":"cq-z","disabled":"dq-z","buttons":"eq-z","feedbackQuestionSection":"fq-z","yesNoWrapper":"gq-z"};